import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";

export const useGetPR01byDateRange = (fromDateTime, toDateTime) => {
  // Helper function to ensure the fromDate starts at 00:00:01
  const formatFromDate = (date) => {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 1);
    return newDate.toISOString().split(".")[0];
  };

  // Helper function to ensure the toDate ends at 23:59:59
  const formatToDate = (date) => {
    const newDate = new Date(date);
    newDate.setHours(23, 59, 59);
    return newDate.toISOString().split(".")[0];
  };

  // Memoize the formatted dates to avoid re-computation on every render
  const formattedFromDate = useMemo(
    () => formatFromDate(fromDateTime),
    [fromDateTime]
  );
  const formattedToDate = useMemo(() => formatToDate(toDateTime), [toDateTime]);

  const fetchData = async () => {
    const queryString = `http://10.250.18.77:8080/mm08export/api/BWOS/GetPR01SummaryPreFiltered?from=${formattedFromDate}&to=${formattedToDate}`;
    const response = await fetch(queryString, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    return response.json();
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["getPR01ByDateRange", formattedFromDate, formattedToDate],
    queryFn: fetchData,
    // The query should be enabled only if both fromDateTime and toDateTime are provided
    enabled: !!fromDateTime && !!toDateTime,
  });

  return { data, isLoading, isError, error };
};
